import { render, staticRenderFns } from "./CommissionRank.vue?vue&type=template&id=a0b8569a&scoped=true&"
import script from "./CommissionRank.vue?vue&type=script&lang=js&"
export * from "./CommissionRank.vue?vue&type=script&lang=js&"
import style0 from "./CommissionRank.vue?vue&type=style&index=0&id=a0b8569a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b8569a",
  null
  
)

export default component.exports